/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useRef, useState } from "react";
import { Button, } from "@mui/material";
import Config from "data/config";
import { SVGIcons } from "cms/icons/svg-icons";
import Notification from "./Notification";
import { Logger } from "cms/utils/log/logger";

const Notifications = () => {
    
    const anchorRef = useRef(null);
    const [open, setOpen] = useState(false);
    // const iconBackColorOpen = 'grey.300'
    // const iconBackColor = 'grey.100'
    
    const onNotificationClick = async () => {
        Logger.info("Clicked onNotificationClick in HeaderContent");
        // Logger.flush()
        setOpen(!open);
    };
    
    return (
        <>
            {Config.features.Notifications.Enabled &&
                <>
                    <Button
                        color='neutral'
                        startIcon={<SVGIcons.common.Bell />}
                        className="text-button-style"
                        onClick={(e) => onNotificationClick(e)}
                        ref={anchorRef}
                    />
                    
                    {/* --- or with badge --- */}
                    {/*<IconButton*/}
                    {/*    disableRipple*/}
                    {/*    color='secondary'*/}
                    {/*    sx={{*/}
                    {/*        color: 'text.primary',*/}
                    {/*        bgcolor: open ? iconBackColorOpen : iconBackColor,*/}
                    {/*    }}*/}
                    {/*    aria-label='open profile'*/}
                    {/*    ref={anchorRef}*/}
                    {/*    aria-controls={open ? 'profile-grow' : undefined}*/}
                    {/*    aria-haspopup='true'*/}
                    {/*    onClick={handleToggle}*/}
                    {/*>*/}
                    {/*    <Badge badgeContent={4} color='accent'>*/}
                    {/*        <BellOutlined />*/}
                    {/*    </Badge>*/}
                    {/*</IconButton>*/}
                    
                    <Notification
                        // handleToggle={handleToggle}
                        open={open}
                        setOpen={setOpen}
                        anchorRef={anchorRef}
                    />
                </>
            }
        </>
    );
};

export { Notifications };
